import React from 'react';

import { Button, Tooltip, Drawer } from 'antd';

import { useSelector } from 'react-redux';
import store from 'app/store';
import MultiDayTabs from './components/multiDayTabs';

import PointsTourFull from './Points/Points';

import { ListMultiTourParts } from './Parts/ListMultiTourParts';

import MultyBuilder from './CreateTour/MultyBuilder';

import AutoSaveTour from './CreateTour/autoSaveTour';
import { ErrorBoundary } from '../../Utility/errorBoundary';

import TextEditor from './components/textEditor';
import { DeleteIcon } from './components/svg';
import TourImageGallery from './components/tourImageGallery';
import withTranslations from '../../HOGs/withTranslations';
import { showDeleteConfirm } from './components/deleteConfirm';
import MainButtons from './components/mainButtons';
import TourFullHeader from './components/header';
import 'react-image-gallery/styles/css/image-gallery.css';
import './tourFull.css';

const GetPointComponent = (props) => {
  const { activeMultiPart } = store.getState().tourFullData;
  const parts = useSelector(
    (store) => store.tourFullData.activeMultiPart.parts
  );

  if (!activeMultiPart || Object.keys(activeMultiPart).length === 0) {
    return null;
  }
  if (parts && parts.length > 1) {
    return <ListMultiTourParts {...props} />;
  }
  return <PointsTourFull {...props} />;
};

const TourContent = (props) => {
  const {
    changeCursorWrapperClassName,
    clearTour,
    closePreview,
    currentTourId,
    edit,
    editChoose,
    fullScreenMode,
    hasUserPermition,
    isClearTour,
    isShapingDataExists,
    isThereAnyWrongRouteInAllTourPages,
    isWrongRoutesExists,
    prevPoly,
    setPageBlock,
    currentUserId,
  } = props;

  return (
    <div className="tourContent">
      <div className="mainInfo">
        <TourFullHeader
          currentTourId={currentTourId}
          edit={edit}
          editChoose={editChoose}
          hasUserPermition={hasUserPermition}
          currentUserId={currentUserId}
        />
        <MultiDayTabs {...props} />
        <MainButtons currentTourId={currentTourId} />
        <TourImageGallery />
        <TextEditor />
        <GetPointComponent {...props} />
      </div>
      <div className="mainMap">
        <ErrorBoundary>
          <MultyBuilder
            multiData={prevPoly}
            isEditable={edit}
            isExistId={!!currentTourId}
            toogleEdit={editChoose}
            changeCursorWrapperClassName={changeCursorWrapperClassName}
            clearTour={clearTour}
            isClearTour={isClearTour}
            fullScreenMode={fullScreenMode}
          />
        </ErrorBoundary>
      </div>
      <ErrorBoundary>
        <AutoSaveTour
          isRidePlan={currentTourId === 0}
          setPageBlock={setPageBlock}
          isWrongRoutesExists={isWrongRoutesExists}
          isThereAnyWrongRouteInAllTourPages={
            isThereAnyWrongRouteInAllTourPages
          }
          fullScreenMode={fullScreenMode}
          isShapingDataExists={isShapingDataExists}
          hasUserPermition={hasUserPermition}
          currentTourId={currentTourId}
          closePreview={closePreview}
          clearTour={clearTour}
        />
      </ErrorBoundary>
    </div>
  );
};

const PrimaryButtons = (props) => {
  const {
    tr,
    editChoose,
    fetching,
    deleteTourDay,
    hasUserPermition,
    getUrl,
    edit,
  } = props;

  const id = useSelector((store) => store.tourFullData.data.id);
  const parts = useSelector((store) => store.tourFullData.data.parts);
  const user = useSelector((store) => store.tourFullData.data.user);
  const multiDay = useSelector((store) => store.tourFullData.data.multiDay);

  const activeTourTab = useSelector(
    (store) => store.tourFullData.activeTourTab
  );

  const queryText =
    activeTourTab > 0 ? tr['Delete the day?'] : tr['Delete the tour?'];

  if (hasUserPermition && !edit) {
    return (
      <>
        <Tooltip title={tr.Delete}>
          <Button
            size="large"
            className="delete-tour-button"
            onClick={() => {
              showDeleteConfirm(
                deleteTourDay,
                queryText,
                tr,
                getUrl('mytour'),
                {
                  id,
                  parts,
                  user,
                  multiDay,
                },
                activeTourTab
              );
            }}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
        <div className="wrappar-main-buttons">
          <Button
            type="primary"
            size="large"
            className="edit-tour-button"
            onClick={fetching === true ? null : () => editChoose(!edit)}
          >
            {tr.Edit}
          </Button>
        </div>
      </>
    );
  }
  return null;
};

const TourFullPreview = (props) => {
  const { tr, handleClose } = props;

  return (
    <>
      <Drawer
        getContainer={false}
        title={false}
        placement="left"
        mask={false}
        closable
        visible
        width="100%"
        style={{ height: 1 }}
        className="createTourContainer createTour"
        onClose={handleClose}
        zIndex={501}
        keyboard={false}
      >
        <div
          className="tourLayout"
          onClick={() => handleClose}
          aria-hidden="true"
        >
          <PrimaryButtons {...props} />
          <TourContent {...props} tr={tr} />
        </div>
      </Drawer>
      <div
        style={{
          width: '100%',
          height: 1,
          position: 'relative',
          zIndex: 500,
        }}
      />
    </>
  );
};

TourFullPreview.displayName = 'TourFullPreview';
TourFullPreview.propTypes = {};

export default withTranslations(TourFullPreview);
